@if (service.state$ | async; as toast) {
  <div class="fixed inset-x-0 bottom-0 flex items-end justify-center z-[9999] pointer-events-none pb-10 sm:pb-14">

    <div
      class="
        animate-notification
        pointer-events-auto
        flex items-center gap-3
        px-6 py-3.5
        w-auto max-w-[90vw]
        bg-white/90 backdrop-blur-2xl

        /* Added a more visible thin border and a crisp double-layer shadow */
        border border-zinc-200/80
        shadow-[0_15px_30px_-10px_rgba(0,0,0,0.1),0_0_1px_rgba(0,0,0,0.2)]

        rounded-full
      ">

      <div
        [ngClass]="{
          'bg-emerald-100 text-emerald-600': toast.type === 'success',
          'bg-red-100 text-red-600': toast.type === 'error',
          'bg-zinc-100 text-zinc-600': toast.type === 'info'
        }"
        class="shrink-0 w-7 h-7 rounded-full flex items-center justify-center">

        @if (toast.type === 'success') {
          <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="3">
            <path stroke-linecap="round" stroke-linejoin="round" d="M5 13l4 4L19 7" />
          </svg>
        } @else if (toast.type === 'error') {
          <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="3">
            <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
          </svg>
        } @else {
          <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24" stroke-width="3">
            <path stroke-linecap="round" stroke-linejoin="round" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
        }
      </div>

      <span class="text-[14px] sm:text-[15px] font-semibold text-zinc-800 tracking-tight">
        {{ toast.message }}
      </span>

    </div>
  </div>
}
